// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"filter-off"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.1552 10.1552L19.5 4H9.5M9.5 4H9L9.01 4.00977L9.5 4ZM5.7002 5.7002L10.5002 12.5002V20.0002H13.5002V13.5002L5.7002 5.7002Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20 20L3 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FilterOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'filter-off',
    ref,
    icon: element,
  },
));

FilterOffIcon.displayName = 'FilterOffIcon';

export default FilterOffIcon;
